import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getStats.operation = 'READ';
getStats.idFrom = 'ARGS';
export function getStats(startDate, endDate) {
    return get(`${API_URL}/usage-source-statistics`, { getData: { startDate, endDate } });
}
